import { LocalDate as LocalDate } from '@js-joda/core';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from './LocalDateTime.mjs';
import {
  Companion_getInstance1hjnoi8x2xjhl as Companion_getInstance,
  MonthBased16lxw4e6nhntg as MonthBased,
  DayBased28hvf1xjg5r93 as DayBased,
} from './DateTimeUnit.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from './DateTimePeriod.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  DateTimeFormatException2onfeknbywaob as DateTimeFormatException,
  DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException,
} from './Exceptions.mjs';
import {
  isJodaDateTimeParseException1w7urgwwcr7j6 as isJodaDateTimeParseException,
  isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException,
  isJodaArithmeticExceptionwen50fdrku5h as isJodaArithmeticException,
} from './JSJodaExceptions.mjs';
import {
  Companion_instance150ikn0lenahv as Companion_instance,
  get_ISO_DATE_BASIC1k4wiybcckf8 as get_ISO_DATE_BASIC,
  get_ISO_DATE1ah0stqy13618 as get_ISO_DATE,
} from './format/LocalDateFormat.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toDayOfWeekfbkpadeytt1z as toDayOfWeek } from './DayOfWeek.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { LocalDateIso8601Serializer_getInstanceny1y5h6nyej8 as LocalDateIso8601Serializer_getInstance } from './serializers/LocalDateSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getIsoDateFormat() {
  return Formats_getInstance().n1o();
}
function atTime(_this__u8e3s4, hour, minute, second, nanosecond) {
  second = second === VOID ? 0 : second;
  nanosecond = nanosecond === VOID ? 0 : nanosecond;
  return LocalDateTime().t1o(_this__u8e3s4.p1o(), _this__u8e3s4.q1o(), _this__u8e3s4.r1o(), hour, minute, second, nanosecond);
}
function minus(_this__u8e3s4, period) {
  var tmp;
  if (!(period.h1m_1 === -2147483648) && !(period.t1m() === -2147483648)) {
    // Inline function 'kotlin.with' call
    var tmp$ret$1 = DatePeriod().m1m(-period.s1m() | 0, -period.t1m() | 0, -period.h1m_1 | 0);
    tmp = plus(_this__u8e3s4, tmp$ret$1);
  } else {
    tmp = minus_0(minus_0(minus_0(_this__u8e3s4, period.s1m(), Companion_getInstance().v1n_1), period.t1m(), Companion_getInstance().t1n_1), period.h1m_1, Companion_getInstance().r1n_1);
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.j25_1 = LocalDate_0().x26(LocalDate.MIN);
        this.k25_1 = LocalDate_0().x26(LocalDate.MAX);
      }
      y26(input, format) {
        var tmp;
        if (format === Formats_getInstance().n1o()) {
          var tmp_0;
          try {
            // Inline function 'kotlinx.datetime.jsTry' call
            // Inline function 'kotlin.let' call
            var p0 = LocalDate.parse(toString(input));
            tmp_0 = LocalDate_0().x26(p0);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var e = $p;
              if (isJodaDateTimeParseException(e))
                throw DateTimeFormatException().y1n(e);
              throw e;
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        } else {
          tmp = format.ev(input);
        }
        return tmp;
      }
      l25(input, format, $super) {
        format = format === VOID ? getIsoDateFormat() : format;
        return $super === VOID ? this.y26(input, format) : $super.y26.call(this, input, format);
      }
      z26(block) {
        return Companion_instance.o1u(block);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance = this;
        this.m1o_1 = get_ISO_DATE_BASIC();
      }
      n1o() {
        return get_ISO_DATE();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance === VOID)
    new (Formats())();
  return Formats_instance;
}
var LocalDateClass;
function LocalDate_0() {
  if (LocalDateClass === VOID) {
    class $ {
      static x26(value) {
        Companion_getInstance_0();
        var $this = createThis(this);
        $this.o1o_1 = value;
        return $this;
      }
      static f1u(year, monthNumber, dayOfMonth) {
        Companion_getInstance_0();
        var tmp;
        try {
          // Inline function 'kotlinx.datetime.jsTry' call
          tmp = LocalDate.of(year, monthNumber, dayOfMonth);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (isJodaDateTimeException(e))
              throw IllegalArgumentException().be(e);
            throw e;
          } else {
            throw $p;
          }
        }
        return this.x26(tmp);
      }
      p1o() {
        return this.o1o_1.year();
      }
      q1o() {
        return this.o1o_1.monthValue();
      }
      r1o() {
        return this.o1o_1.dayOfMonth();
      }
      g1u() {
        return toDayOfWeek(this.o1o_1.dayOfWeek());
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof LocalDate_0()) {
            tmp_0 = this.o1o_1 === other.o1o_1 || this.o1o_1.equals(other.o1o_1);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.o1o_1.hashCode();
      }
      toString() {
        return this.o1o_1.toString();
      }
      a27(other) {
        return this.o1o_1.compareTo(other.o1o_1);
      }
      d(other) {
        return this.a27(other instanceof LocalDate_0() ? other : THROW_CCE());
      }
      h1s() {
        return numberToInt(this.o1o_1.toEpochDay());
      }
    }
    initMetadataForClass($, 'LocalDate', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalDateIso8601Serializer_getInstance});
    LocalDateClass = $;
  }
  return LocalDateClass;
}
function plusNumber(_this__u8e3s4, value, unit) {
  var tmp;
  try {
    var tmp_0;
    if (unit instanceof DayBased()) {
      // Inline function 'kotlinx.datetime.jsTry' call
      tmp_0 = _this__u8e3s4.o1o_1.plusDays(numberToInt(numberToDouble(value) * unit.j1n_1));
    } else {
      if (unit instanceof MonthBased()) {
        // Inline function 'kotlinx.datetime.jsTry' call
        tmp_0 = _this__u8e3s4.o1o_1.plusMonths(numberToInt(numberToDouble(value) * unit.k1n_1));
      } else {
        noWhenBranchMatchedException();
      }
    }
    // Inline function 'kotlin.let' call
    var p0 = tmp_0;
    tmp = LocalDate_0().x26(p0);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (!isJodaDateTimeException(e) && !isJodaArithmeticException(e))
        throw e;
      throw DateTimeArithmeticException().l1o('The result of adding ' + toString(value) + ' of ' + toString(unit) + ' to ' + _this__u8e3s4.toString() + ' is out of LocalDate range.', e);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function plus(_this__u8e3s4, period) {
  var tmp;
  try {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.run' call
    var $this$run = _this__u8e3s4.o1o_1;
    var tmp_0;
    if (!(period.g1m_1 === 0)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      tmp_0 = $this$run.plusMonths(period.g1m_1);
    } else {
      tmp_0 = $this$run;
    }
    // Inline function 'kotlin.run' call
    var $this$run_0 = tmp_0;
    var tmp_1;
    if (!(period.h1m_1 === 0)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      tmp_1 = $this$run_0.plusDays(period.h1m_1);
    } else {
      tmp_1 = $this$run_0;
    }
    // Inline function 'kotlin.let' call
    var p0 = tmp_1;
    tmp = LocalDate_0().x26(p0);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e) || isJodaArithmeticException(e))
        throw DateTimeArithmeticException().k1o(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
}
function minus_0(_this__u8e3s4, value, unit) {
  return plusNumber(_this__u8e3s4, -value | 0, unit);
}
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstancefc1kb6w5z78x,
  LocalDate_0 as LocalDate31mqn6zavbpi8,
  atTime as atTime2v4vw3esgoteo,
  minus as minushnjyym3nfk5o,
};
//endregion

//# sourceMappingURL=LocalDate.mjs.map
